export default [
    {
        id: 'welcome',
        type: 'welcome',
        title: 'Bienvenue dans notre réseau de collaborateurs !',
        description:
            'Vous pouvez maintenant mettre à profit vos réseaux en y faisant circuler des contenus URBANIA. <strong>Plus vous partagez, plus vous récoltez.</strong> Simple de même.',
    },
    {
        id: 'step-list',
        type: 'step',
        title: '1',
        description:
            'Naviguez sur le site et choisissez <strong>un contenu que vous aimeriez partager.</strong>',
    },
    {
        id: 'step-page',
        type: 'step',
        title: '2',
        description:
            '<strong>Cliquez sur l’icône de partage.</strong> (seulement visible si vous êtes connecté à votre compte)',
    },
    {
        id: 'step-link',
        type: 'step',
        title: '3',
        description:
            '<strong>Copiez le lien fourni par l’outil de partage.</strong> Il contient un identifiant unique à vous.',
    },
    {
        id: 'step-share',
        type: 'step',
        title: '4',
        description:
            '<strong>Utilisez ce lien dans vos publications,</strong> ajoutez-y un soupçon de sel et le tour est joué!',
    },
    {
        id: 'end',
        type: 'end',
        title: null,
        description:
            'Notre système associera à votre compte et les impressions issues de vos initiatives afin que vous puissiez récolter le fruit de vos efforts. <strong>Le tout sera résumé dans votre tableau de bord,</strong> accessible dans votre compte.',
    },
];
